import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ISSUE_STATUS = {
    CREATED: 'created',
    CLOSED: 'closed',
    REOPEN: 'reopen',
    WONT_DO: 'wont_do',
};

export const ENDPOINTS = deepFreeze({
    BRANDS: {
        URI: () => '/api/v1/catalog/brands/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        default: {},
        cacheToClear: ['/api/v1/catalog/brands'],
    },
    CATEGORIES: {
        URI: () => '/api/v1/catalog/categories/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        default: {},
        cacheToClear: ['/api/v1/catalog/categories'],
    },
    MANUFACTURERS: {
        URI: () => '/api/v1/catalog/manufacturers/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        default: {},
        cacheToClear: ['/api/v1/catalog/manufacturers'],
    },
    PRODUCTS: {
        URI: () => '/api/v1/catalog/products/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        default: {},
        cacheToClear: ['/api/v1/catalog/products'],
    },
    IMPORT_ISSUES: {
        URI: () => '/api/v1/catalog/import-issues/{{id?}}',
        methods: ['get', 'patch'],
        cacheToClear: ['/api/v1/catalog/import-issues'],
    },
    IMPORT_ISSUES_DETAILS: {
        URI: () => '/api/v1/catalog/import-issues/{{id}}/details',
        methods: ['get'],
    },
    DUPLICATES: {
        URI: () => '/api/v1/catalog/products/{{id}}/duplicates',
        methods: ['post'],
        cacheToClear: ['/api/v1/catalog/products', '/api/v1/catalog/variants'],
    },
    VARIANT_OFFERS: {
        URI: () => '/api/v1/catalog/variants/{{id}}/offers',
        methods: ['get'],
    },
    VARIANTS: {
        URI: () => '/api/v1/catalog/variants/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        cacheToClear: ['/api/v1/catalog/variants', '/api/v1/catalog/variants/{{id}}/offers'],
    },
    VARIANT_IMAGES: {
        URI: () => '/api/v1/catalog/variants/{{id}}/images/{imageId}',
        methods: ['post'],
        cacheToClear: ['/api/v1/catalog/variants'],
    },
    VARIANTS_IMAGES: {
        URI: () => '/api/v1/catalog/variants{{variantGtin}}/images/{{imageId}}',
        methods: ['post'],
    },
    OFFERS: {
        URI: () => '/api/v1/catalog/offers/{{id?}}',
        methods: ['get', 'post', 'patch', 'delete'],
        cacheToClear: ['/api/v1/catalog/offers', '/api/v1/catalog/variants/\\d+/offers', '/api/v1/offers/\\d+/moderation', '/api/v1/offers/moderation'],
    },
    VARIANT_WITH_PRODUCT: {
        URI: () => '/api/v1/catalog/variant-with-product',
        methods: ['post'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
